import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getListDetailsChartEntradaMercancia = (query) => http.get(`${api}/compras-catalogo/list-details-chart-em`, { params: { ...query } })

export {
  getListDetailsChartEntradaMercancia
}
